module.exports = __webpack_public_path__ + "static/media/swissAlps_Switzerland.229d3bd9.jpg";